<app-loading-bar />
<!-- <app-loading *ngIf="loadingPage"></app-loading> -->

<!-- Start::menú -->
<div class="block sm:hidden">
  <app-menu-categoria-mobile />
</div>
<div class="hidden sm:block">
  <app-menu-categorias />
</div>
<!-- End::menú -->

<!-- site -->
<div class="site site_b2c flex">
  <!-- mobile site__header -->
  <header class="site__header inline lg:hidden">
    <app-mobile-header />
  </header>
  <!-- mobile site__header / end -->

  <!-- desktop site__header -->
  <header class="site__header hidden lg:inline">
    <app-header />
  </header>
  <!-- desktop site__header / end -->

  <!-- site__body -->
  <div class="site__body">
    <router-outlet />
  </div>
  <!-- site__body / end -->

  <!-- <app-feature-section /> -->
  <!-- site__footer -->
  <footer class="site__footer">
    <app-footer />
  </footer>
  <!-- site__footer / end -->
  <!-- <app-chat *ngIf="isBrowser"></app-chat> -->
</div>
<!-- site / end -->
